module.exports = __webpack_public_path__ + "img/acacia_mweya2.2e90ad11.jpeg";